export default "<email-sign></email-sign>\n"